  document.addEventListener('DOMContentLoaded', function () {
    const cartButtons = document.querySelectorAll('#add-to-cart-button');

    cartButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault();

            const variantId = this.dataset.variantId;

            if (!variantId) {
                console.error('Variant ID is missing.');
                return;
            }
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: parseInt(variantId, 10), 
                    quantity: 1
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error adding product to cart: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                console.log('Product added to cart successfully:', data);
                openCartDrawer();
                updateCartDrawer();
            })
            .catch(error => {
                console.error('Failed to add product to cart:', error);
            });
        });
    });

    function openCartDrawer() {
        const cartDrawer = document.getElementById('shopify-section-cart-drawer');
        if (cartDrawer) {
            cartDrawer.classList.add('active');
        }
    }

    function updateCartDrawer() {
        fetch('?section_id=cart-drawer')
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCartContents = doc.querySelector('.cart__inner');

                if (newCartContents) {
                    const cartDrawerContents = document.querySelector('.cart__inner');
                    if (cartDrawerContents) {
                        cartDrawerContents.innerHTML = newCartContents.innerHTML;
                    }
                }
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        const cartIcon = document.querySelector('.cart-icon-quantity');
                        if (cartIcon) {
                            cartIcon.textContent = cart.item_count;
                        }
                    });
            })
            .catch(error => {
                console.error('Failed to update the cart drawer:', error);
            });
    }
});